module.exports = __webpack_public_path__ + "img/jiantouBottom.03e7b0e5.svg";